import { messageNarration, type NarrationLine } from '../narration-line.ts';

export function narrateDeepResearch(props: Record<string, unknown>): NarrationLine {
  const currentSearch = typeof props.currentSearch === 'string' ? props.currentSearch : '';
  if (!currentSearch) {
    return messageNarration('researchingInitial');
  }
  return messageNarration('researching', { currentSearch });
}

export const PROCESS_NARRATIONS: Record<string, (props: Record<string, unknown>) => NarrationLine> =
  {
    DeepResearch: narrateDeepResearch,
  };
